module.exports = __webpack_public_path__ + "img/voice-thumb2.978d5d4.jpg";